module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.10769/assets/images/new-and-updated-apps.png"